// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__24Mzi","box":"Error_box__37VND"};